import Phaser from "phaser";
import { textStyle } from "../ui/textStyles";

interface ResultData {
  victory: boolean;
}

export default class ResultScene extends Phaser.Scene {
  constructor() {
    super("ResultScene");
  }

  create(data: ResultData): void {
    const { width, height } = this.scale.gameSize;
    this.add.rectangle(0, 0, width, height, 0x000000, 0.85).setOrigin(0, 0).setDepth(0);

    const title = data.victory
      ? "Победа! Лилит и Голди выгнали соперников."
      : "Поражение... Голди слишком стесняется.";

    this.add
      .text(
        width / 2,
        height / 2 - 30,
        title,
        textStyle(8, "#ffffff", {
          align: "center",
          wordWrap: { width: width - 40 },
        }),
      )
      .setOrigin(0.5, 0.5)
      .setDepth(1);

    const button = this.add
      .text(width / 2, height / 2 + 20, "[ Заново ]", textStyle(16, "#ffcc55"))
      .setOrigin(0.5, 0.5)
      .setDepth(1)
      .setInteractive({ useHandCursor: true });

    button.on("pointerdown", () => this.restart());
    button.on("pointerover", () => button.setColor("#ffffff"));
    button.on("pointerout", () => button.setColor("#ffcc55"));

    this.input.keyboard?.once("keydown-ENTER", () => this.restart());
    this.input.keyboard?.once("keydown-SPACE", () => this.restart());
  }

  private restart(): void {
    this.scene.start("BattleScene");
  }
}
